//  翻訳テキスト（自前辞書）
export const translations = {
	ja: {
		device: '機器',
		lead: 'お客さま保有の風力発電機情報を入力頂くことで、提供する機器と診断サービスの情報を確認することができます。',
		windmillmaker: '■風車メーカー',
		capacity: '■発電容量',
		devices:'■旋回駆動装置台数',
		motor: '■駆動装置付属モーター',
		ebrake: '■付属電磁ブレーキ',
		power: '電源',
		current: '電流',
		boltsize: '■駆動装置締結ボルトサイズ',
		kanza: '■間座',
		img: 'イメージ',
		method:'■駆動装置設置方式',
		service: '診断サービス',
		loadyear: '■希望契約年数',
		specification: '標準仕様（負荷情報を閲覧することができます）',
		load: '■負荷診断',
		option: 'オプション（メンテナンス情報を閲覧することができます）',
		remaininglife:'■余寿命診断',
		oil: '駆動装置オイル',
		gear: '駆動装置 歯車・軸受',
		brake: '電磁ブレーキ',
		exp: '導入CMFSの機器と診断サービス仕様を確認いただけます',
		diagnosis: '出力する',
		placeholder: '選択してください',
		input:'入力して下さい',
		inputerror:'入力エラー',
		loading: '診断中...',
		product: '製品選定',
		equipment:'CMFS機器サンプル',
		equiptext: '風力発電機1基あたりの機器構成と数量',
		equip1: 'ボルト歪センサ',
		equip2: '信号変換ボックス',
		equip3: '制御ボックス',
		equip4: '電源ボックス',
		equipnote: '※100V電源が必要となります。その他ケーブル類、通信用アンテナが付属されます。',
		analysis:'負荷診断サンプル',
		ana1:'監視風車設置マップ',
		ana2:'負荷分布図',
		ana3:'異常発生履歴表',
		remainsample:'余寿命診断サンプル',
		mailbtn: 'メール送信する場合はこちら',
		action: '/diagnosis-result-email',
		},
	en: {
		device: 'Equipment',
		lead: 'By inputting data on your own wind turbine, you can obtain information about the CMFS and diagnostic services suitable for the turbine.',
		windmillmaker: '■Wind turbine manufacturer',
		capacity: '■Power generation capacity',
		devices:'■Number of yaw drive units',
		motor: '■Motor attached to the drive unit',
		ebrake: '■Electromagnetic brake attached to it',
		power: 'Power source',
		current: 'Electric current',
		boltsize: '■Size of bolt used to fasten the drive unit',
		kanza: '■Spacer ',
		img: 'image',
		method:'■Drive unit installation method',
		service: 'Diagnostic Service',
		loadyear: '■Number of years you want to receive the service',
		specification: 'Standard specifications (including load information)',
		load: '■Load diagnosis',
		option: 'Options (including maintenance information)',
		remaininglife:'■Diagnosis of the remaining life of the yaw drive unit',
		oil: 'Lubricant oil',
		gear: 'Gear and bearing',
		brake: 'Electromagnetic brake',
		exp: '(You can check the CMFS and diagnostic service specifications)',
		diagnosis: 'Output',
		placeholder: 'Please select',
		input:'Must to be filled',
		inputerror:'Input error',
		loading: 'Under diagnosis ...',
		product: 'Product selection',
		equipment:'Product selection',
		equiptext: 'System configuration and quantity for each wind turbine',
		equip1: 'Bolt strain sensor',
		equip2: 'Signal conversion box',
		equip3: 'CMFS BOX',
		equip4: 'Power supply box',
		equipnote: 'A 100V power supply is required. Other cables and communication antenna are included.',
		analysis:'Load diagnosis sample',
		ana1:'Wind turbine installation map',
		ana2:'Load distribution graph',
		ana3:'Table showing the record of occurrence of abnormalities',
		remainsample:'Life diagnosis sample',
		mailbtn: 'Click here to send an email',
		action: '/en/diagnosis-result-email',
	},
	de: {
		device: 'Equipment',
		lead: 'Durch die Eingabe der Daten zu Ihrer Windkraftanlage werden Ihnen Informationen zur angebotenen CMFS-Ausrüstung und dem Prüfdienst bereitgestellt',
		windmillmaker: '■Windradhersteller',
		capacity: '■Stromerzeugungskapazität',
		devices:'■Anzahl der Rotationsantriebe',
		motor: '■Motor mit Antriebseinheit',
		ebrake: '■Mit elektromagnetischer Bremse',
		power: 'Stromversorgung',
		current: 'Elektrisch',
		boltsize: '■Größe der Befestigungsschrauben der Antriebseinheit',
		kanza: '■Abstandshalter',
		img: 'image',
		method:'■Installation der Antriebseinheit',
		service: 'Prüfdienst',
		loadyear: '■Gewünschte Vertragsjahre',
		specification: 'Standardspezifikationen (Lastinformationen anzeigen lassen)',
		load: '■Belastungsprüfung',
		option: 'Zusätzliche Optionen (Wartungsinformationen anzeigen lassen)',
		remaininglife:'■Prüfung der verbleibenden Lebensdauer',
		oil: 'Antriebsöl',
		gear: 'Antriebszahnrad/-lager',
		brake: 'Elektromagnetische Bremse',
		exp: '(Sie können die installierte CMFS-Ausrüstung und die Spezifikationen des Prüfdienstes anzeigen lassen.)',
		diagnosis: 'Ausgeben',
		placeholder: 'Bitte auswählen',
		input:'Muss ausgefüllt werden',
		inputerror:'Input error',
		loading: 'Wird geprüft ...',
		product: 'Produktauswahl',
		equipment:'Muster einer CMFS-Ausrüstung',
		equiptext: 'Ausstattung und Anzahl je Windkraftanlage',
		equip1: 'Dehnungssensor für Schrauben',
		equip2: 'Signalumwandlungsbox',
		equip3: 'Steuerungskasten',
		equip4: 'Stromversorgungskasten',
		equipnote: '*100 V-Stromversorgung erforderlich. Andere Kabel und Kommunikationsantennen sind im Lieferumfang enthalten',
		analysis:'Musterprüfung zur Belastung',
		ana1:'Karte der Installation von Windkraftanlagen',
		ana2:'Lastverteilungsdiagramm',
		ana3:'Tabelle, die die Aufzeichnung des Auftretens von Anomalien zeigt',
		remainsample:'Musterprüfung zur verbleibenden Lebensdauer',
		mailbtn: 'Klicken Sie hier, um eine E-Mail zu senden',
		action: '/de/diagnosis-result-email',
	},
}
